import axios from "axios";

const axiosInstance = axios.create();

const params = new URLSearchParams(window.location.search);
const appsmith_key = params.get("appsmith_key");

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }else{
      config.headers["x-internal-api-key"] = appsmith_key;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
